import angular from 'angular'
import sygem from './sygem/sygem'

angular.module('app', [sygem,])



// WEBPACK FOOTER //
// ./public/javascript/app.js